// -------------------------------------------------------------------------------------------------
// Import
// -------------------------------------------------------------------------------------------------

import $ from 'jquery';
import runOnVisible from '../runner-visible';
import Tooltip from 'bootstrap/js/src/tooltip';

// -------------------------------------------------------------------------------------------------
// Variables
// -------------------------------------------------------------------------------------------------

const baseClass = 'tooltip-icon';

// -------------------------------------------------------------------------------------------------
// Classes
// -------------------------------------------------------------------------------------------------

export class TooltipIcon {
  constructor(el) {
    this.el = el;

    runOnVisible(this.el, async () => {
      await this.start();
    });
  }

  async start() {
    var myTooltipEl = this.el
    var tooltip = new Tooltip(myTooltipEl)
  }
}

// -------------------------------------------------------------------------------------------------
// Methods
// -------------------------------------------------------------------------------------------------

function init() {
  $(`.${baseClass}`).each((i, el) => new TooltipIcon(el));
}


// -------------------------------------------------------------------------------------------------
// Export
// -------------------------------------------------------------------------------------------------

export default {
  init
};
